import './client/styles.css';
import { Store } from './client/store.js';
import { WSClient } from './client/ws.js';
import { mountUi } from './client/ui/render.js';

const store = new Store();
const ws = new WSClient(store.get().name || 'Spieler');

const root = document.getElementById('app');
if (!root) throw new Error('#app missing');

mountUi(root, store, ws);
ws.connect();
